import { FC } from 'react';
import VictimIcon from 'images/victim-icon-black.svg';

const VictimIconBlack: FC = () => {
  return <img src={VictimIcon} alt="new-sinisters-icon" />;
};
export default VictimIconBlack;
